// extracted by mini-css-extract-plugin
export var divider = "_wf-0";